import { ActionDp, Logger, LogOptions, setLogger } from 'telemetry';
import { DatapointOptions } from 'owa-analytics-actions';
import { logUsage, PerformanceDatapoint } from 'owa-analytics';

/** Initialize logger with logUsage and PerformanceDatapoint from owa-analytics */
export function initializeLogger() {
    setLogger(MiniAppLogger);
}

const MiniAppLogger: Logger = {
    logData: (eventName: string, logData?: any, logOptions?: LogOptions) =>
        logUsage(eventName, logData, logOptions as DatapointOptions),

    getActionDp: (eventName: string, options?: LogOptions): ActionDp =>
        new PerformanceDatapoint(eventName, options as DatapointOptions),
};
